import { axiosInstance } from '@/rest/axios'

export const usersApi = {
  /**
   * Submit the account's closure; profile-search checks it holds no orders,
   * positions or cash before asking Apex, and answers 409 with the reason.
   */
  closeAccount: (account_number) =>
    axiosInstance.post(`v2/users/accounts/${account_number}/close`),
}
